import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Crown, Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6">
      <div className="w-full max-w-md lk-card p-10" data-testid="admin-login">
        <div className="flex items-center gap-3 mb-8">
          <Crown className="w-7 h-7 text-[#D4AF37]" />
          <span className="font-serif text-2xl">
            <span className="text-white">Luxury</span>{" "}
            <span className="gold-gradient-text">Kingz</span>
          </span>
        </div>
        <p className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-2">Admin</p>
        <h1 className="font-serif text-3xl mb-8">Sign in.</h1>
        <form onSubmit={submit} className="space-y-6">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-zinc-500">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="lk-input mt-2"
              data-testid="admin-email"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-zinc-500">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="lk-input mt-2"
              data-testid="admin-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="lk-btn-primary text-xs w-full flex items-center justify-center gap-2"
          >
            {loading && <Loader2 size={14} className="animate-spin" />}
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
